import React from 'react';
import ReactDOM from 'react-dom';
import configStore, { sagaMiddleware } from './store';
import { Provider } from 'react-redux';
import { rootSaga } from './saga/root-saga';
import { withErrorBoundary } from '@optic-delight/benefitsolver-services';
import App from './App';
import { AppFallback } from './client/AppFallback';

import '@optic-delight/bootstrap-theme-benefitsolver/build/theme.css';

if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_BACKEND === 'true') {
	const { worker } = require('./mocks/browser');
	worker.start();
}

const root = document.getElementById('hc-root');
const Wrapped = withErrorBoundary(App, {
	FallbackComponent: AppFallback
});
ReactDOM.render(
	<Provider store={configStore()}>
		<Wrapped />
	</Provider>,
	root
);

sagaMiddleware.run(rootSaga);
